import { render, staticRenderFns } from "./ShopCategoryScore.vue?vue&type=template&id=155fdabc&scoped=true"
import script from "./ShopCategoryScore.vue?vue&type=script&lang=js"
export * from "./ShopCategoryScore.vue?vue&type=script&lang=js"
import style0 from "./ShopCategoryScore.vue?vue&type=style&index=0&id=155fdabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155fdabc",
  null
  
)

export default component.exports